import React, { useEffect, useState } from 'react'
import './AdminTeamList.css'
import { NavLink } from 'react-router-dom'
import Modal from '../../shared/components/UIElements/Modal'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import AdminNavigation from './AdminNavigation'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminVideoList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [loadedVideos, setLoadedVideos] = useState()
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [deletedVideoId, setDeletedVideoId] = useState('')
	const [videoDeleted, setVideoDeleted] = useState()

	//First, lets tap into the following route on the backend to get all videos:
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setVideoDeleted(false)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + `/admin/videos`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedVideos(responseData.allVideos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [videoDeleted])

	const errorHandler = () => {
		setError(null)
	}

	//******************************************************** */
	//
	//     Delete warning
	//
	//******************************************************** */
	const showDeleteWarningHandler = (e) => {
		const value = e.target.id
		setDeletedVideoId(loadedVideos[value]._id)
		setShowConfirmModal(true)
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
	}

	//console.log('league right here: ' + leagueId)
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${deletedVideoId}/removeVideo`,
				'DELETE'
			)
		} catch (err) {}
		setVideoDeleted(true)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete this video?
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE VIDEO
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && loadedVideos && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>Videos</h1>
					<h5>
						Use this page to add YouTube videos. Video urls must be YouTube!
					</h5>
					<h5>
						Videos added here can be viewed either on the home page, or you can
						assign them to an individual player's page.
					</h5>
					<table id='teams'>
						<thead>
							<tr>
								<th>Title</th>
								<th>URL</th>
								<th>Caption</th>
								<th>Location</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedVideos.map((video, key) => {
								return (
									<tr key={key}>
										<td>{video.videoTitle}</td>
										<td>{video.videoURL}</td>
										<td>{video.videoCaption}</td>
										{video.who == 'home' && <td>Home</td>}
										{video.who !== 'home' && <td>{video.who}'s Page</td>}
										<td>
											<NavLink
												className='navlinks'
												to={`/admin/updateVideo/${video._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
										<td>
											<button
												className='buttonButton'
												style={{ color: 'red' }}
												id={key}
												onClick={(e) => showDeleteWarningHandler(e)}
											>
												DELETE
											</button>
										</td>
									</tr>
								)
							})}
						</tbody>
						<div style={{ width: '150%', marginTop: '1rem' }}>
							<AdminButton
								to={`/admin/video/new`}
								exact
								style={{
									color: 'white',
									textDecoration: 'none',
								}}
							>
								Add a new Video
							</AdminButton>
						</div>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminVideoList
